// extracted by mini-css-extract-plugin
export default {"container":"dcc_attributeFilterResultPlaceholder-container","title":"dcc_attributeFilterResultPlaceholder-title","content":"dcc_attributeFilterResultPlaceholder-content"};